import { useEffect } from 'react';

/**
 * 리스트가 채워졌을 때 첫 항목을 자동 선택.
 * - selectedId가 비어있고 items에 첫 항목 있으면 itemKey(items[0])를 onSelect로 통지
 */
export const useAutoSelectFirst = <T,>(
  items: T[] | null | undefined,
  selectedId: any,
  onSelect: (id: any) => void,
  itemKey: (item: T) => any = (it: any) => it?.id
) => {
  useEffect(() => {
    if (selectedId == null && Array.isArray(items) && items.length > 0) {
      const id = itemKey(items[0]);
      if (id != null) onSelect(id);
    }
  }, [items, selectedId, onSelect, itemKey]);
};
